import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Card from "components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { store } from "../../_store";
// import {apiActions} from "../../_actions/api.actions";
import { alertActions, commonActions } from "../../_actions";
// import { startAction, stopAction } from "../../_actions/progress.actions";
import { EmptyRecord } from "../../utils/PageUtility";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from '../../utils/CircularProgress';
import ReconciliationPanel from './ReconciliationPanel'
import ReconciliationTable from './ReconciliationTable'
import MyReconciliationTable from './MyReconciliationTable'
import Tabs from "components/CustomTabs/CustomTabs.jsx";

// material icons
import ReconciliationIcon from "@material-ui/icons/RestorePage";
import { appHelpers } from "../../_helpers";

const statusTypes = [
    {name: "Select Status", value: "Placeholder"},
    { name: "Pending", value: 0 },
    { name: "Approved", value: 1 },
    { name: "Declined", value: 2 }
];

const reconciliationTypes = [
    {name: "Select Reconciliation Type", value: "Placeholder"},
    { name: "Debit", value: 0 },
    { name: "Credit", value: 1 }
];

const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);


class Reconciliation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            airlines: [],
            users: [],
            name: '',
            airlineName: '',
            airports: [],
            airportName: "",
            airportCode: "-1",
            newAirportCode: "-1",
            reconciliationData: [],
            myReconciliationData: [],
            AirlineId: '-1',
            Type: '',
            Status: 0,
            startDate: aMonthAgo,
            endDate: today,
            reconciliationType: '',
            status: '',
            isProgressActive: true,
            currentPage: 1,
            pageSize: 10,
            totalPaymentCount: 0,
            requestingReconciliation: true,
            isOpen: false,
            isEditModalOpen: false,
            error: false,
            formError: '',
            newToken: '',
            newTokenRate: '',
            newAirlineId: '-1',
            narration: '',
            newType: '',
            pendingReconId: '',
            reconId: '',
            isCommentModalOpen: false,
            comment: '',
            processName: '',
            airlineError: false,
            airportError: false,
            tokenError: false,
            narrationError: false,
            typeError: false

        };
    }


    componentDidMount() {
        const { airports, user } = store.getState();
        let { pageSize, startDate, endDate, Status } = this.state;

        const { dispatch } = this.props;
        this.fetchAirlines()
        this.fetchUsers()
        //  this.loadReconciliationData()
        this.fetchTokenRate()
        if (airports) {
            this.setState({ airports })
        } else {
            dispatch(commonActions.getAllAirports());
        }

        if (user.Location) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({airportCode: userLocation, newAirportCode: userLocation});
            let payload = {
                StartDate: appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD"),
                EndDate: appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD"),
                From: 1,
                Size: pageSize,
                UserId: user.userId,
                Status: Status,
                AirportCode: user.AirportCode
            };
            this.loadReconciliationData(payload);
        }else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = {...user};
            let userLocation = {value: userObj.AirportCode, label: userObj.Location};
            this.setState({ airportCode: userLocation, newAirportCode: userLocation });
            let payload = {
                StartDate: appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD"),
                EndDate: appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD"),
                From: 1,
                Size: pageSize,
                UserId: user.userId,
                Status: Status,
                AirportCode: user.AirportCode
            };
            this.loadReconciliationData(payload);
        } else {
            this.loadReconciliationData()
        }
    }

    componentWillReceiveProps = function (nextProps) {
        const { airlines, airports, users } = nextProps;
        const { dispatch } = this.props;

        if (airlines) {
                let modifiedAirline = [...airlines];
                let allAirlines = {Airline: "All Airlines", AirlineId: "-1"};
                modifiedAirline.unshift(allAirlines);
                this.setState({ airlines: modifiedAirline });
        }
        if (users) {
            this.setState({ users: users.ResultList });
        }
        if (airports) {
            let modifiedAirport = [...airports];
            modifiedAirport.unshift({Name: "All Airports", Code: "-1"});
            this.setState({ airports: modifiedAirport })
        } else {
            dispatch(commonActions.getAllAirports());
        }
    };

    loadReconciliationData = (payload) => {
        this.searchReconciliation(1, payload)
        this.searchMyReconciliation(1, payload)
    }

    handleDateChange = (date, target) => {
        // console.log('date', date);
        this.setState({ [target]: date });
    };

    // fetch users
    fetchUsers = () => {
        const { dispatch, users } = this.props
        if (users) {
            this.setState({ users: users.ResultList })
        }
        else {
            dispatch(commonActions.getAllUsers());
        }
    }

    // fetch airlines
    fetchAirlines = () => {

        let { airlines } = store.getState();
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest())

        if (airlines) {
            dispatch(alertActions.stopRequest())
            this.setState({ airlineData: airlines, dataCount: airlines.Count })
        } else {
            dispatch(commonActions.getAllAirlines())
            setTimeout(() => {
                dispatch(alertActions.stopRequest())
            }, 3000)
        }
    }

    // method: display name of airlineId
    filterAirlines = (airlineId) => {
        const { airlines } = this.state;
        let airlineName = airlines.find(u => u.AirlineId === airlineId);
        if (airlineName) {
            return `${airlineName.Airline}`
        } else {
            return 'Unknown Airline'
        }
    }


    //Displays Airport Name
    filterAirport = (airportCode) => {
        const { airports } = this.state;
        let result = airports.find(item => item.Code === airportCode);
        let name = result ? result.Name : "Unknown Airport"
        return name
    }

    // method: display name of userId
    filterUsers = (userId) => {
        const { users } = this.state;
        if (users) {
            if (userId === null) {
                return ""
            } else {
                let userName = users.find(u => u.Id === userId);
                if (userName) {
                    return `${userName.FirstName} ${userName.LastName}`
                } else {
                    return 'Unknown User'
                }
            }
        }
    }

    // display name of statusId
    filterStatus = (statusId) => {
        let status = statusTypes.find(item => item.value === statusId)
        if (status) {
            return `${status.name}`
        } else {
            return 'Unknown Status'
        }
    }

    // approve a reconcilation
    approveReconciliation = () => {

        const { user, dispatch } = this.props
        let userId = user.userId
        const payload = {
            PendingReconciliationId: this.state.reconId,
            ProcessedBy: userId,
            Status: 1,
            Comment: this.state.comment
        }

        dispatch(alertActions.startRequest());

        commonService.processReconciliation(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response));
                    this.closeCommentModal()
                    this.searchReconciliation()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            })
    }

    // decline a reconciliation
    declineReconciliation = () => {

        const { user, dispatch } = this.props
        let userId = user.userId
        const payload = {
            PendingReconciliationId: this.state.reconId,
            ProcessedBy: userId,
            Status: 2,
            Comment: this.state.comment
        }

        dispatch(alertActions.startRequest());

        commonService.processReconciliation(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify(res.response));
                    this.closeCommentModal()
                    this.searchReconciliation()

                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }

            })
    };

    handleReactSelectChange = (value, name) => {
        // console.log({value}, {name})
        this.setState({[name.name]: value})
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights"){
            this.setState({[name.name]: "-1"} )
        }
    };

    handleSelectChange = prop => event => {
        // console.log(prop)
        // console.log(event.target.value)
        this.setState({ [prop]: event.target.value });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    // fetch token rate
    fetchTokenRate = () => {
        const { dispatch } = this.props

        commonService.getCurrentPsc()
            .then((res) => {
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        newTokenRate: response.PscCharge
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            })
    }

    //search reconciliation with parameters
    searchReconciliation = (pageNumber = 1, payload) => {
        let { AirlineId, airportCode, pageSize, startDate, endDate, Status, Type } = this.state;
        const { dispatch, user } = this.props;
        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                UserId: user.userId
            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (airportCode !== "-1") {
                payload.AirportCode = airportCode.value
            }
            if (Status !== "") {
                payload.Status = Status.value
            }
            if (Type !== "") {
                payload.ReconciliationType = Type.value
            }
        }

        dispatch(alertActions.startRequest());
        commonService.getOtherReconciliation(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber,
                        totalCount: response.TotalCount,
                        reconciliationData: response.PendingReconciliation,
                        requestingReconciliation: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingReconciliation: false });
                }
            })
    };

    //search user-created reconciliations with parameters
    searchMyReconciliation = (pageNumber = 1, payload) => {
        let { AirlineId, airportCode, pageSize, startDate, endDate, Type, Status } = this.state;
        const { dispatch, user } = this.props;

        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");
        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                UserId: user.userId
            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (airportCode !== "-1") {
                payload.AirportCode = airportCode.value
            }
            if (Type !== "") {
                payload.ReconciliationType = Type.value
            }
            if (Status !== "") {
                payload.Status = Status.value
            }
        }


        dispatch(alertActions.startRequest());
        commonService.getMyReconciliation(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                // console.log('recon response', response);
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        myCurrentPage: pageNumber,
                        myTotalCount: response.TotalCount,
                        myReconciliationData: response.PendingReconciliation,
                        requestingReconciliation: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingReconciliation: false });
                }
            })
    };

    //open add reconciliation modal
    handleOpenModal = () => {
        this.setState({ isOpen: true })
    };

    // close add reconciliation modal
    handleCloseModal = () => {
        this.setState({
            isOpen: false,
            airlineError: false,
            tokenError: false,
            narrationError: false,
            typeError: false
        });
        this.resetForm()
    };

    //open edit reconciliation Modal
    openEditModal = (item) => {
        this.setState({ isEditModalOpen: true })
        this.setState({
            newAirportCode: item.AirportCode,
            newAirlineId: item.AirlineId,
            newToken: item.Token,
            narration: item.Narration,
            newType: ((item.Iscredit) ? 1 : 0),
            pendingReconId: item.Id
        })
    };

    // close edit reconciliation modal
    closeEditModal = () => {
        this.setState({
            isEditModalOpen: false, airlineError: false,
            tokenError: false,
            narrationError: false,
            typeError: false
        });
    };

    // open comment modal
    openCommentModal = (reconId, action) => {
        this.setState({
            reconId,
            isCommentModalOpen: true,
            processName: action
        })
    }

    // close comment modal
    closeCommentModal = () => {
        this.setState({
            isCommentModalOpen: false,
            reconId: "",
            comment: ""
        })
    }


    // update reconciliation
    handleUpdate = (reconId) => {

        const { newToken, newTokenRate, narration, newAirlineId, newType, newAirportCode } = this.state
        const { user, dispatch } = this.props

        if (!newAirportCode || newAirportCode === "Placeholder") {
            this.setState({ airportError: true })
        } else {
            this.setState({ airportError: false })
        }

        if (newAirlineId === "" || newAirlineId === "Placeholder") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (newToken === "") {
            this.setState({ tokenError: true })
        } else {
            this.setState({ tokenError: false })
        }

        if (narration === "") {
            this.setState({ narrationError: true })
        } else {
            this.setState({ narrationError: false })
        }

        if (newType === "") {
            this.setState({ typeError: true })
        } else {
            this.setState({ typeError: false })
        }

        if (!newAirportCode || newAirlineId === "" || newAirlineId === "Placeholder" || newToken === "" || narration === "" || newType === "") {
            return
        }

        const payload = {
            PendingReconciliationId: reconId,
            AirlineId: newAirlineId,
            AirportCode: newAirportCode,
            Token: newToken,
            TokenRate: newTokenRate,
            Narration: narration,
            ReconciliationType: newType,
            CreatedBy: user.userId
        }
        dispatch(alertActions.startRequest());

        commonService.updateReconciliation(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {

                    dispatch(alertActions.notify(res.response));
                    this.closeEditModal()
                    this.searchMyReconciliation()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        requestingReconciliation: false
                    });
                }
            })
    }

    // add new reconciliation
    handleSubmit = () => {

        const { newToken, newTokenRate, narration, newAirlineId,
            newType, newAirportCode
        } = this.state
        const { user, dispatch } = this.props;

        if (!newAirportCode || newAirportCode === "-1") {
            this.setState({ airportError: true })
        } else {
            this.setState({ airportError: false })
        }

        if (newAirlineId === "" || newAirlineId === "-1") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (newToken === "") {
            this.setState({ tokenError: true })
        } else {
            this.setState({ tokenError: false })
        }

        if (narration === "") {
            this.setState({ narrationError: true })
        } else {
            this.setState({ narrationError: false })
        }

        if (newType === "") {
            this.setState({ typeError: true })
        } else {
            this.setState({ typeError: false })
        }

        if (!newAirportCode || newAirlineId === "" || newAirlineId === "-1" || newToken === "" || narration === "" || newType === "") {
            return
        }
        const payload = {
            AirportCode: newAirportCode.value,
            AirlineId: newAirlineId.value,
            Token: newToken,
            TokenRate: newTokenRate,
            Narration: narration,
            ReconciliationType: newType.value,
            CreatedBy: user.userId
        }
        dispatch(alertActions.startRequest());

        commonService.addReconciliation(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {

                    dispatch(alertActions.notify(res.response));
                    this.handleCloseModal()
                    this.searchMyReconciliation()
                    this.resetForm()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    // console.log(res.response)
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        requestingReconciliation: false
                    });
                }
            })
    };

    resetForm = () => {
        const {newAirportCode} = this.state;
        const { user } = this.props;
        const newAirportCode_ = (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? newAirportCode: "-1";
        this.setState({
            newToken: "", narration: "", newType: "",
            newAirportCode: newAirportCode_, newAirlineId: "-1"
        })
    };

    render() {
        const { airlines, reconciliationData, AirlineId, airlineName,
            startDate, endDate, currentPage, pageSize, totalCount,
            requestingReconciliation, Type, Status, isOpen, isEditModalOpen,
            newToken, newTokenRate, newAirlineId, narration, newType,
            pendingReconId, isCommentModalOpen, comment, processName,
            formError, error, myReconciliationData, myCurrentPage,
            airlineError, narrationError, tokenError, typeError, airports,
             airportCode, airportName, newAirportCode,
            myTotalCount, airportError } = this.state;

        let { requesting, user } = this.props;

        if (requestingReconciliation)
            return (
                <CircularProgress />
            );
        return (
            <div>

                <ReconciliationPanel
                    user={this.props.user}
                    formError={formError}
                    airlineError={airlineError}
                    airportError={airportError}
                    narrationError={narrationError}
                    tokenError={tokenError}
                    typeError={typeError}
                    error={error}
                    airline={airlineName}
                    AirlineId={AirlineId.value}
                    airports={airports}
                    airportName={airportName}
                    airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
                    newAirportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? newAirportCode : newAirportCode.value}
                    Type={Type.value}
                    Status={Status.value}
                    selectChange={this.handleReactSelectChange}
                    selectAirlineChange={this.handleSelectChange}
                    selectTypeChange={this.handleSelectChange}
                    selectStatusChange={this.handleSelectChange}
                    data={airlines}
                    onSearch={this.loadReconciliationData}
                    startDate={startDate}
                    endDate={endDate}
                    startLabel='Start Date'
                    endLabel='End Date'
                    handleDateChange={this.handleDateChange}
                    handleEndDateChange={this.handleDateChange}
                    isOpen={isOpen}
                    handleOpenModal={this.handleOpenModal}
                    handleSubmit={this.handleSubmit}
                    handleClose={this.handleCloseModal}
                    handleChange={this.handleChange}
                    newToken={newToken}
                    newTokenRate={newTokenRate}
                    narration={narration}
                    newAirlineId={newAirlineId.value}
                    newType={newType.value}
                    reconciliationTypes={reconciliationTypes}
                    statusTypes={statusTypes}
                    requesting={requesting}
                />

                <GridContainer>
                    <Tabs
                        headerColor="success"
                        tabs={[
                            {
                                tabName: "My Reconciliations",
                                tabIcon: ReconciliationIcon,
                                tabContent: (
                                    <GridItem xs={12} sm={12} md={12}>
                                        {
                                            !requestingReconciliation && myTotalCount !== 0
                                            &&
                                            <MyReconciliationTable
                                                formError={formError}
                                                error={error}
                                                airlineError={airlineError}
                                                airportError={airportError}
                                                narrationError={narrationError}
                                                tokenError={tokenError}
                                                typeError={typeError}
                                                reconciliationData={myReconciliationData}
                                                currentPage={myCurrentPage}
                                                pageSize={pageSize}
                                                fetchReconciliation={this.searchMyReconciliation}
                                                totalCount={myTotalCount}
                                                filterAirlines={this.filterAirlines}
                                                filterAirport={this.filterAirport}
                                                filterUsers={this.filterUsers}
                                                filterStatus={this.filterStatus}
                                                // approveReconciliation={this.approveReconciliation}
                                                // declineReconciliation={this.declineReconciliation}
                                                editReconciliation={this.editReconciliation}
                                                openEditModal={this.openEditModal}
                                                closeEditModal={this.closeEditModal}
                                                isEditModalOpen={isEditModalOpen}
                                                handleChange={this.handleChange}
                                                handleUpdate={this.handleUpdate}
                                                newToken={newToken}
                                                newTokenRate={newTokenRate}
                                                narration={narration}
                                                newAirlineId={newAirlineId}
                                                newType={newType}
                                                airports={airports}
                                                airportCode={airportCode}
                                                newAirportCode={newAirportCode}
                                                pendingReconId={pendingReconId}
                                                airlines={airlines}
                                                selectAirlineChange={this.handleSelectChange}
                                                selectTypeChange={this.handleSelectChange}
                                                reconciliationTypes={reconciliationTypes}
                                                disabled={requesting}
                                            // isCommentModalOpen={isCommentModalOpen}
                                            // openCommentModal={this.openCommentModal}
                                            // closeCommentModal={this.closeCommentModal}
                                            // comment={comment}
                                            // processName={processName}
                                            />}

                                        {
                                            !requestingReconciliation && myTotalCount === 0
                                            && <EmptyRecord message={'No reconciliation record'} />
                                        }
                                    </GridItem>

                                )
                            },
                            {
                                tabName: "All Reconciliations",
                                tabIcon: ReconciliationIcon,
                                tabContent: (
                                    <GridItem xs={12} sm={12} md={12}>
                                        {
                                            !requestingReconciliation && totalCount !== 0
                                            &&
                                            <ReconciliationTable
                                                formError={formError}
                                                error={error}
                                                reconciliationData={reconciliationData}
                                                currentPage={currentPage}
                                                pageSize={pageSize}
                                                fetchReconciliation={this.searchReconciliation}
                                                totalCount={totalCount}
                                                filterAirlines={this.filterAirlines}
                                                filterUsers={this.filterUsers}
                                                filterStatus={this.filterStatus}
                                                approveReconciliation={this.approveReconciliation}
                                                declineReconciliation={this.declineReconciliation}
                                                // editReconciliation={this.editReconciliation}
                                                // openEditModal={this.openEditModal}
                                                // closeEditModal={this.closeEditModal}
                                                // isEditModalOpen={isEditModalOpen}
                                                handleChange={this.handleChange}
                                                handleUpdate={this.handleUpdate}
                                                newToken={newToken}
                                                newTokenRate={newTokenRate}
                                                narration={narration}
                                                newAirlineId={newAirlineId}
                                                newType={newType}
                                                pendingReconId={pendingReconId}
                                                airlines={airlines}
                                                aiports={airports}
                                                airportCode={airportCode}
                                                newAirportCode={newAirportCode}
                                                selectAirlineChange={this.handleSelectChange}
                                                selectTypeChange={this.handleSelectChange}
                                                reconciliationTypes={reconciliationTypes}
                                                isCommentModalOpen={isCommentModalOpen}
                                                openCommentModal={this.openCommentModal}
                                                closeCommentModal={this.closeCommentModal}
                                                comment={comment}
                                                processName={processName}
                                                filterAirport={this.filterAirport}
                                                disabled={requesting}
                                            />}

                                        {
                                            !requestingReconciliation && totalCount === 0
                                            && <EmptyRecord message={'No reconciliation record'} />
                                        }
                                    </GridItem>
                                )
                            }
                        ]}
                    />
                </GridContainer>

            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { modal, alert, airports, airlines, reconciliation, user,
        users, requesting } = state;
    return {
        modal,
        alert,
        airlines,
        reconciliation,
        user,
        users,
        airports,
        requesting
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(Reconciliation)));



// WEBPACK FOOTER //
// ./src/views/Reconciliation/Index.jsx